import mostrarLoading from '../actions/util/mostrarLoading'
import fecharLoading from '../actions/util/fecharLoading'

export const SLOW_REQUEST_HEADER = 'X-Slow-Request'
export const SLOW_REQUEST_CONFIG = { headers: { [SLOW_REQUEST_HEADER]: true } }

let _store
function getStore() {
  if (!_store) {
    _store = require('../store/configureStore').default
  }
  return _store
}

export const iniciarLoading = () => {
  getStore().dispatch(mostrarLoading())
}

export const finalizarLoading = () => {
  getStore().dispatch(fecharLoading())
}
